import { setMatchmakingValue } from "../redux-actions/battle-actions.js";
import Skins from "../_data/Skins.js";
import { getLoadout } from "../Fixture_combatants.js";
import store from "../init/store.js";
import { getSiblingInArray } from "../helpers/get-sibling-in-array.js";
import {
  setInitialCombatantData,
  updateCrewNameInRoom
} from "../battle/connection/firebase-rooms.js";
import { setCrewValue } from "../redux-actions/battle-actions.js";
import {
  setUserCrewMemberInFirebase,
  setUserCrewName
} from "../battle/connection/firebase-users.js";
import { getUserUnlocks } from "../b5-unlocks/getUserUnlocks.js";

//Update only the Name field of `editingCombatantProperties`
export function changeEditingCombatantValue(property, newValue) {
  setMatchmakingValue({
    editingCombatantProperties: {
      ...store.getState().matchmaking.editingCombatantProperties,
      [property]: newValue
    }
  });
}

//Provide next or previous resources from lists
export function getNextSkin(currentSkinId: string, direction: "next" | "prev") {
  const allSkins = Object.keys(Skins());
  const unlocks = getUserUnlocks();

  //Filter skins for only available ones (based on unlock, or just things we shouldn't allow you to select)
  const availableSkins = allSkins.filter(skinId => {
    if (skinId === "skin_mystery") {
      return false;
    }
    if (skinId === "skin_bonus1") {
      return unlocks["unlockC"].isComplete;
    }
    if (skinId === "skin_bonus2") {
      return unlocks["unlockD"].isComplete;
    }

    //Default to true
    return true;
  });

  const currentIndex = availableSkins.indexOf(currentSkinId);
  return getSiblingInArray(availableSkins, currentIndex, direction);
}

export function getNextLoadout(
  currentLoadoutId: string,
  direction: "next" | "prev"
) {
  //Filter available ids by unlocks
  const unlocks = getUserUnlocks();
  const allLoadouts = [
    {
      id: "dpsA",
      test: function() {
        return true;
      }
    },
    {
      id: "dpsB",
      test: function() {
        return true;
      }
    },
    {
      id: "dpsC",
      test: function() {
        return unlocks["unlockA"].isComplete;
      }
    },
    {
      id: "disruptA",
      test: function() {
        return true;
      }
    },
    {
      id: "disruptB",
      test: function() {
        return true;
      }
    },
    {
      id: "disruptC",
      test: function() {
        return unlocks["unlockB"].isComplete;
      }
    },
    {
      id: "supportA",
      test: function() {
        return true;
      }
    },
    {
      id: "supportB",
      test: function() {
        return true;
      }
    },
    {
      id: "supportC",
      test: function() {
        return unlocks["unlockE"].isComplete;
      }
    }
  ]
    .filter(loadout => {
      return loadout.test();
    })
    .map(loadout => loadout.id); //["dpsA", "dpsB" ...], etc

  const currentIndex = allLoadouts.indexOf(currentLoadoutId);
  return getSiblingInArray(allLoadouts, currentIndex, direction);
}

//Do something with the finished result.
//Use this to set values on an existing character config somewhere.
export function handleEditingDone() {
  //Get the finished config.
  const {
    editingId,
    combatantName,
    combatantSkin,
    combatantLoadoutId
  } = store.getState().matchmaking.editingCombatantProperties;

  //Lookup the loadout to use.
  const myLoadoutData = getLoadout(combatantLoadoutId);

  //Edit local Crew state with my changes
  const currentCrew = store.getState().crew.members;
  setCrewValue({
    members: {
      ...currentCrew,
      [editingId]: {
        ...currentCrew[editingId], //Include whatever I was before
        ...myLoadoutData, //Merge in my new loadout data
        name: combatantName, //and any updates that would have been done in the modal...
        skinId: combatantSkin,
        loadoutId: combatantLoadoutId
      }
    }
  });

  //Close the modal
  setMatchmakingValue({
    //Default "not active" model.
    editingCombatantProperties: {
      isActivated: false
    }
  });

  //If we are in a firebase room, update the edited combatant in `initialCombatantData`
  if (window.roomRef) {
    //NOTE: This check for roomRef could *portentially* cause issues if you WERE in a room, and now you're not. (window.roomRef still defined)
    //Keep an eye out for that. You might be editing a room that you're not in anymore.

    const currentRoomCombatantData = store.getState().matchmaking
      .initialCombatantData;
    const updatedCrewMembers = store.getState().crew.members;

    let combatantUpdate = {};
    let firebaseCombatantKey = null;
    Object.keys(currentRoomCombatantData).forEach(key => {
      const memberId = currentRoomCombatantData[key].memberId;
      if (memberId === editingId) {
        firebaseCombatantKey = key;
        combatantUpdate = {
          ...updatedCrewMembers[memberId]
        };
      }
    });
    setInitialCombatantData(firebaseCombatantKey, combatantUpdate);
  }

  //Now we also need to send this to the user's account. window.roomRef does not matter, but being logged in does.
  setUserCrewMemberInFirebase(store.getState().crew.members);
}

export function launchEditModal(combatantId) {
  //Populate the modal with exising data from local Crew
  const currentCombatantModel = store.getState().crew.members[combatantId];

  setMatchmakingValue({
    editingCombatantProperties: {
      isActivated: true,
      editingId: combatantId,

      combatantName: currentCombatantModel.name,
      combatantSkin: currentCombatantModel.skinId,
      combatantLoadoutId: currentCombatantModel.loadoutId
    }
  });
}

export function editCrewName(newCrewName) {
  setCrewValue({
    name: newCrewName
  });

  //Update my account with crewname.
  setUserCrewName(); //(Checks if logged in)

  //If in multiplayer mode, write crew to our name!
  updateCrewNameInRoom(); //(Checks if in a multiplayer room)
}

export function getSafeCombatantName(inputName) {

  //Remove anything but letters, numbers, and spaces
  let safeString = inputName.replace(/[^\w\s!?]/g,'');

  //iOS can auto suggest your name which is super long.
  if (safeString.length > 10) {

  }

  if (inputName.length <= 1 || inputName.match(/^[0-9]/)) {
    return "Mister QA"
  }

  return safeString;
}


// WEBPACK FOOTER //
// ./src/b5-crew-management/edit-combatant-operations.js